import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { PageNotFound } from "../components/admin/SuperAdmin/NotFound";
import ParentAdminRoutes from "./ParentAdminRoutes";
import SuperAdminRoutes from "./SuperAdminRoutes";
import StudentAdminRoutes from "./StudentAdminRoutes";
import HomePageRoutes from "./HomePageRoutes";
import NewHomePageRoutes from "./NewHomePageRoutes";
import { ForgotPassword } from "../components/admin/SuperAdmin/ForgotPassword/ForgotPassword";
import SchoolAdminRoutes from "./SchoolAdminRoutes";
import TeacherAdminRoutes from "./TeacherAdminRoutes";
import { SignupForm } from "../components/WebUi/Signup/Signup";
import { KidSetPassword } from "../components/admin/SuperAdmin/ResetPassword/ResetPassword";
import { ResetPasswordAll } from "../components/admin/SuperAdmin/ResetPassword/ResetPasswordAll";
import { PaymentStatus } from "../components/admin/ParentAdmin/Payment/PaymentStatusPage";
import { EmailVerification } from "../components/admin/ParentAdmin/VerificationEmail/EmailVerification";
import ScrollToTop from "../components/admin/SuperAdmin/ScrollToTop";
import SessionExpired from "../components/common/sessionLogout";
import { AccessDenied } from "../components/common/accessDenied";
import ReferralRedirect from "../components/admin/SuperAdmin/Referral/ReferralRedirect";
import { ParentInvitationSetup } from "../components/admin/ParentAdmin/Register/InvitationParent";
import AccountVerifiedPage from "../components/admin/ParentAdmin/Register/ParentVerifiedPage";
import { getSubdomain } from "../utils/subdomian";
import TeacherLogin from "../components/admin/TeacherAdmin/login/TeacherLogin";
import TeacherForgotPassword from "../components/admin/TeacherAdmin/forgotPassword/TeacherForgotPassword";
import TeacherChangePassword from "../components/admin/TeacherAdmin/changePassword/TeacherChangePassword";
import TeanantPublicRoutes from "./TeanantPublicRoutes";
import SchoolStudentAdminRoutes from "./SchoolStudentAdminRoutes";
import SchoolTeacherSetPassword from "../components/admin/TeacherAdmin/setPassword/TeacherSetPassword";
import StudentSetPassword from "../components/admin/StudentAdmin/SetPassword/StudentSetPassword";
import OrganisationRoutes from "./OrganisationRoutes";
import SchoolParentAdminRoutes from "./SchoolParentAdminRoutes";
import SchoolParentSetPassword from "../components/admin/ParentAdmin/SchoolParentSetPassword/SchoolParentSetPassword";
import SchoolParentDashboardRoutes from "./SchoolParentDashboardRoutes";

const LoginRedirect = () => {
  const location = useLocation();
  return <Navigate to={{ pathname: "/", search: location.search }} replace />;
};

const AppRoutes = () => {
  const subdomain = getSubdomain();

  return (
    <>
      <ScrollToTop />
      <Routes>
        {subdomain ? (
          <Route
            path="/login"
            element={
              <TeanantPublicRoutes>
                <TeacherLogin />
              </TeanantPublicRoutes>
            }
          />
        ) : (
          <Route path="/login" element={<LoginRedirect />} />
        )}

        {subdomain && (
          <Route
            path="/forgot-password"
            element={
              <TeanantPublicRoutes>
                <TeacherForgotPassword />
              </TeanantPublicRoutes>
            }
          />
        )}

        {subdomain && (
          <Route
            path="/tenant/reset-password"
            element={
              <TeanantPublicRoutes>
                <TeacherChangePassword />
              </TeanantPublicRoutes>
            }
          />
        )}

        {/* <Route path="/forgotpassword" element={<ForgotPassword />} /> */}
        <Route path="/session-expired" element={<SessionExpired />} />
        <Route path="/access-denied" element={<AccessDenied />} />
        {/* <Route path="/signup" element={<SignupForm />} /> */}
        {/* Parent email verification */}
        <Route path="/email-verify" element={<EmailVerification />} />
        <Route path="/kid-set-password" element={<KidSetPassword />} />
        <Route path="/reset-password" element={<ResetPasswordAll />} />
        <Route path="/i/:slug" element={<ReferralRedirect />} />
        <Route
          path="/school-parent/set-password"
          element={<SchoolParentSetPassword />}
        />

        {subdomain && (
          <Route path="/school-admin/*" element={<SchoolAdminRoutes />} />
        )}
        {subdomain && (
          <Route
            path="/school-parent/*"
            element={<SchoolParentDashboardRoutes />}
          />
        )}
        {subdomain && (
          <Route path="/teacher/*" element={<TeacherAdminRoutes />} />
        )}
        {subdomain && (
          <Route path="/student/*" element={<SchoolStudentAdminRoutes />} />
        )}
        {subdomain && (
          <Route path="/organization/*" element={<OrganisationRoutes />} />
        )}

        {subdomain && (
          <Route
            path="/tenant/set-password"
            element={<SchoolTeacherSetPassword />}
          />
        )}

        {subdomain && (
          <Route
            path="/tenant/student/set-password"
            element={<StudentSetPassword />}
          />
        )}

        <Route path="/student/*" element={<StudentAdminRoutes />} />
        <Route path="/parent/*" element={<ParentAdminRoutes />} />
        <Route path="/school-parent/*" element={<SchoolParentAdminRoutes />} />

        {HomePageRoutes()}
        {NewHomePageRoutes()}
        {SuperAdminRoutes()}

        <Route path="/paypal/result" element={<PaymentStatus />} />
        <Route path="/stripe/result" element={<PaymentStatus />} />
        <Route path="/razorpay/result" element={<PaymentStatus />} />
        <Route
          path="/setup-partner-account"
          element={<ParentInvitationSetup />}
        />
        <Route
          path="/setup-partner-account/verified"
          element={<AccountVerifiedPage />}
        />

        {/* 404 Handling */}
        <Route path="/not-found" element={<PageNotFound />} />
        <Route path="*" element={<Navigate to="/not-found" replace />} />
        {/* <Route path="*" element={<PageNotFound />} /> */}
      </Routes>
    </>
  );
};

export default AppRoutes;
